import React, { useState, useRef, useEffect } from "react";
// import { render } from "react-dom";
import { Row } from "react-bootstrap";
// import ProfileIcon from '../../assets/img/organization-icons/profile.png';
// import ConfigurationIcon from '../../assets/img/organization-icons/settings.png';
// import CompanyIcon from '../../assets/img/organization-icons/shop.png';
// import NotificationIcon from '../../assets/img/organization-icons/notification.png';
import "../../assets/styles/settings/organizationprofile.scss";
import OrganizationService from "../../services/organization";
import { Controller, useForm, useFieldArray } from "react-hook-form";
// import { faCropSimple } from '@fortawesome/free-solid-svg-icons';
import { RiDeleteBin5Line } from "react-icons/ri";
import { Dropdown, Toast } from "../PrimeReact";
import Configuration from "./Configuration";
import GV from "../../services/globalVar";
import { iconSet, IcomoonReact, Tooltip, BlockUI } from "../PrimeReact.js";
import OnBoardConfig from "./OnBoardConfig";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { TabView, TabPanel } from "primereact/tabview";
import { Steps } from "primereact/steps";
import { ProgressSpinner } from "primereact/progressspinner";
import { useLocation } from "react-router-dom"; 

//.required('This field is required')  28
//.required('This field is required').email('Provide a valid email')
let schema = yup.object().shape({
  cname: yup.string().required("This field is required"),
  companytype: yup.string().required("This field is required"),
  dname: yup.string().required("This field is required"),
  owner: yup.string().required("This field is required"),
  // country: yup.string().required('This field is required'),
  pEmail: yup.string().required("This field is required"),
  pcontact: yup.string().required("This field is required"),
  about: yup.string(),

  industryType: yup.string().required("This field is required"),
  compRegId: yup.string().required("This field is required"),
  panNo: yup.string().required("This field is required"),
  licenseName: yup.string().required("This field is required"),
  licenseNo: yup.string().required("This field is required"),
  taxId: yup.string().required("This field is required"),
  taxNo: yup.string().required("This field is required"),
  siteLink: yup.string(),

  //billDetails
  address1: yup.string().required("This field is required"),
  // address2:yup.string().required('This field is required') ,
  bcity: yup.string().required("This field is required"),
  bstate: yup.string().required("This field is required"),
  bcountry: yup.string().required("This field is required"),
  bzip: yup.string().required("This field is required"),

  //bankDetails
  bankname: yup.string().required("This field is required"),
  branch: yup.string().required("This field is required"),
  ifsc: yup.string().required("This field is required"),
  acctNo: yup.string().required("This field is required"),
  accntName: yup.string().required("This field is required"),

  orgAddresses: yup.array().of(
    yup.object().shape({
      orgbaddress1: yup.string().required("This field is required"),
      orgbcity: yup.string().required("This field is required"),
      orgbstate: yup.string().required("This field is required"),
      orgbcountry: yup.string().required("This field is required"),
      orgbzip: yup.string().required("This field is required"),
    })
  ),
});

export default function OrganizationProfile(props) {
  const isConfigCompleted = GV.userDet.tenantConfig.isConfigCompleted;
  const toast = useRef(null);
  const [selectetdFile, setSelectedFile] = useState([]);
  const [fileBase64String, setFileBase64String] = useState("");
  const [selectetdFile1, setSelectedFile1] = useState([]);
  const [fileBase64String1, setFileBase64String1] = useState("");
  const [imgName, SetImgName] = useState("");
  const [fileList, SetFileList] = useState(false);
  const [imgName1, SetImgName1] = useState("");
  const [fileList1, SetFileList1] = useState(false);
  const [orgStateLists, setOrgStateLists] = useState({});
  const [isProcess, setIsProcess] = useState(isConfigCompleted ? true : false);

  ///////////api get in call//////////
  // const [organizationData, setOrganizationData] = useState([]);
  const [isMounted, setIsMounted] = useState(true);
  /////////////// dropdown get call ///////////
  const [industryData, setIndustryData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [orgCountryData, setOrgCountryData] = useState([]);
  const [tdataLoaded, setTdataLoaded] = useState(false);
  const [cdataLoad, setCdataLoaded] = useState("Init");
  const [stateData, setStateData] = useState([]);

  const [selectedState, setSelectedState] = useState();
  const [selectedIndustry, setSelectedIndustry] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState();
  const [logo, setLogo] = useState("");
  const [shortLogo, setShortLogo] = useState("");
  const [logo1, setLogo1] = useState("");
  const [showImg, setShowImg] = useState(false);
  const [showImg1, setShowImg1] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [showShortLogo, setShowShortLogo] = useState(false);

  const [tenantInfo, setTenantInfo] = useState();
  const org = new OrganizationService();

  const defaultValues = {
    cname: "",
    companytype: "",
    dname: "",
    owner: "",
    industryType: "",
    pEmail: "",
    pcontact: "",
    compRegId: "",
    panNo: "",
    licenseName: "",
    licenseNo: "",
    taxId: "",
    taxNo: "",
    siteLink: "",
    about: "",

    // billDetails
    address1: "",
    bcity: "",
    bstate: "",
    bcountry: "",
    bzip: "",

    orgAddresses: [
      {
        orgbaddress1: "",
        orgbcity: "",
        orgbstate: "",
        orgbcountry: "",
        orgbzip: "",
      },
    ],

    bankname: "",
    branch: "",
    ifsc: "",
    acctNo: "",
    accntName: "",
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "orgAddresses",
  });

  const BusinessType = [
    { label: "Type 1", value: "T1" },
    { label: "Type 2", value: "T2" },
    { label: "Type 3", value: "T3" },
    { label: "Type 4", value: "T4" },
    { label: "Type 5", value: "T5" },
  ];

  // const countries = [
  //     { label: 'India', value: 'IND' },
  //     { label: 'Australia', value: 'AUS' },
  //     { label: 'America', value: 'USA' },
  // ];

  const state = [
    { label: "Tamil Nadu", value: "TN" },
    { label: "Karnataka", value: "KA" },
    { label: "Uttar Pradesh", value: "UP" },
  ];
  const stepItems = [{ label: "Company Profile" }, { label: "Configuration" }];
  //logo
  const [fileValidation, setFileValidation] = useState("");
  const [ftypeValidate, setFtypeValidate] = useState(false);
  const onFileChange = (e) => {
    let minFileSize = 1024;
    setFtypeValidate(false);
    setFileValidation("");
    let selectedFileType = e.target.files[0].name;
    const lastSegment = selectedFileType.substring(
      selectedFileType.lastIndexOf(".") + 1
    );
    let selectedFileSize = e.target.files[0].size;

    if (e.target.files.length > 0) {
      if (
        lastSegment !== "jpeg" &&
        lastSegment !== "jpg" &&
        lastSegment !== "png"
      ) {
        setFtypeValidate(true);
        setFileValidation("Supported formats are JPEG,JPG,PNG only");
      } else if (selectedFileSize >= 1048576) {
        setFileValidation("File size should be less than 2 MB");
      } else {
        SetFileList(true);
        setSelectedFile(e.target.files);
        encodeImageBase64(e.target.files[0]);
        SetImgName(e.target.files[0].name);
        // setShowImg(e.target.files[0]);
        setShowImg(false);
        setLogo("");
        setShowLogo(true);
        setFileValidation("");

        const data = {
          TenantID: GV.userDet.tenantDetail.tenantID,
          IsLogoChanged: true,
          IsSmallLogoChanged: false,
        };

        const formData = new FormData();
        formData.append("InputJson", JSON.stringify(data));
        formData.append("Logo", e.target.files[0]);
        formData.append("SmallLogo", "");
        org.SaveTenantLogo(formData).then((res) => {
          if (res.data.message == "Document Updated") {
            toast.current.show({
              severity: "success",
              summary: "Successfully Updated Logo",
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Failed to update Logo",
            });
          }
        });
      }
    }
  };

  const encodeImageBase64 = (file) => {
    var reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        var Base64 = reader.result;
        setFileBase64String(Base64);
        // setLogo(Base64);
      };
      reader.onerror = (error) => {};
    }
  };

  const decodeImageBase64 = (base64String) => {
    return decodeURIComponent(
      base64String
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  };

  const decodeBase64 = decodeImageBase64(
    fileBase64String.substring(fileBase64String.indexOf(",") + 1)
  );

  // short logo
  const [fileValidation1, setFileValidation1] = useState("");
  const [ftypeValidate1, setFtypeValidate1] = useState(false);
  const onFileChange1 = (e) => {
    //  encodeImageBase64short(selectetdFile);
    setFtypeValidate1(false);
    setFileValidation1("");
    let selectedFileType = e.target.files[0].name;
    const lastSegment = selectedFileType.substring(
      selectedFileType.lastIndexOf(".") + 1
    );
    let selectedFileSize = e.target.files[0].size;

    if (e.target.files.length > 0) {
      if (
        lastSegment !== "jpeg" &&
        lastSegment !== "jpg" &&
        lastSegment !== "png"
      ) {
        setFtypeValidate1(true);
        setFileValidation1("Supported formats are JPEG,JPG,PNG only");
      } else if (selectedFileSize >= 1048576) {
        setFileValidation1("File size should be less than 2 MB");
      } else {
        setSelectedFile1(e.target.files);
        encodeImageBase64short(e.target.files[0]);
        SetFileList1(true);
        SetImgName1(e.target.files[0].name);
        setShowImg1(false);
        setShortLogo("");
        setShowShortLogo(true);
        let idCard = e.target.files[0];
        let idCardBase64 = "";

        const data = {
          TenantID: GV.userDet.tenantDetail.tenantID,
          IsLogoChanged: false,
          IsSmallLogoChanged: true,
        };
        const formData = new FormData();
        formData.append("InputJson", JSON.stringify(data));
        formData.append("Logo", "");
        formData.append("SmallLogo", e.target.files[0]);
        org.SaveTenantLogo(formData).then((res) => {
          if (res.data.message == "Document Updated") {
            toast.current.show({
              severity: "success",
              summary: "Successfully Updated Logo",
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Failed to update Logo",
            });
          }
        });
      }
    }
  };

  const encodeImageBase64short = (file) => {
    var reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        var Base64 = reader.result;
        setFileBase64String1(Base64);
      };
      reader.onerror = (error) => {};
    }
  };
  const decodeImageBase64short = (base64String1) => {
    // From Bytestream to Percent-encoding to Original string
    return decodeURIComponent(
      base64String1
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  };

  const decodeBase64short = decodeImageBase64short(
    fileBase64String1.substring(fileBase64String1.indexOf(",") + 1)
  );
  //get call
  function getOrganizationData() {
    let tid = GV.userDet.tenantDetail.tenantID;
    setIsProcess(true);
    org
      .GetTenantDetails(tid)
      .then((response) => {
        if (!isMounted) return;

        if (response?.data?.statusCode === 200) {
          const resp = response.data.data;
          console.log(resp, "resp");
          setTenantInfo(resp);
          setTdataLoaded(true);

          // Scalar fields
          setValue("cname", resp.tenantName);
          setValue("dname", resp.shortName);
          setValue("owner", resp.administratorName);
          setValue("pEmail", resp.email);
          setValue("pcontact", resp.primaryPhone);
          setValue("industryType", resp.industryType);
          setValue("companytype", resp.companyType);
          setValue("compRegId", resp.companyID);
          setValue("panNo", resp.panNo);
          setValue("licenseName", resp.licenseName);
          setValue("licenseNo", resp.licenseNo);
          setValue("taxId", resp.taxID ?? "");
          setValue("taxNo", resp.taxNumber);
          setValue("siteLink", resp.website);
          setValue("about", resp.description);

          // Bill details
          setValue("address1", resp.billAddress1);
          setValue("bcity", resp.billCity);
          setValue("bcountry", resp.billCountry);
          changeCountryProfile(resp.billCountry);
          setValue("bzip", resp.billZipCode);
          setValue("bstate", resp.billState);

          // Bank details
          setValue("bankname", resp.bankName);
          setValue("branch", resp.bankBranch);
          setValue("ifsc", resp.ifscCode);
          setValue("acctNo", resp.bankAccountNo);
          setValue("accntName", resp.bankAccountName);

          // Logos
          if (resp.logo) {
            setLogo(resp.logo);
            setShowImg(true);
            setShowLogo(false);
          }
          if (resp.smallLogo) {
            setShortLogo(resp.smallLogo);
            setShowImg1(true);
            setShowShortLogo(false);
          }

          const serverAddrs = (resp.originatingAddressList ?? []).map((a) => ({
            orgAddressID: a.orgAddressID || 0,
            orgbaddress1: a.address1 ?? "",
            orgbcity: a.city ?? "",
            orgbstate: a.state ?? "",
            orgbcountry: a.country ?? "",
            orgbzip: a.zipCode ?? "",
          }));

          replace(
            serverAddrs.length
              ? serverAddrs
              : [
                  {
                    orgbaddress1: "",
                    orgbcity: "",
                    orgbstate: "",
                    orgbcountry: "",
                    orgbzip: "",
                  },
                ]
          );

          const stateFetches = serverAddrs.map((address, index) => {
            const countryObject = orgCountryData.find(
              (c) => c.countryName === address.orgbcountry
            );
            if (countryObject) {
              return org
                .GetState(countryObject.countryID)
                .then((stateResponse) => {
                  if (stateResponse.data?.statusCode === 200) {
                    return { index, stateList: stateResponse.data.data };
                  }
                  return null;
                })
                .catch(() => null);
            }
            return null;
          });

          Promise.all(stateFetches.filter(Boolean)).then((results) => {
            const newOrgStateLists = { ...orgStateLists };
            results.forEach((result) => {
              if (result) {
                newOrgStateLists[result.index] = result.stateList;
              }
            });
            setOrgStateLists(newOrgStateLists);
          });
        } else {
          setTdataLoaded(false);
        }
        setIsProcess(false);
      })
      .catch((error) => {
        console.error(error);
        setIsProcess(false);
      });
  }
  // useEffect(() => {
  //     // getOrganizationData();
  //     return () => { setIsMounted(false); }
  // }, []);
  // logo

  const handleRemove = (index) => {
    remove(index);
    const newOrgStateLists = { ...orgStateLists };
    delete newOrgStateLists[index];
    const updatedStateLists = {};
    Object.keys(newOrgStateLists)
      .sort((a, b) => a - b)
      .forEach((oldIndex, newIndex) => {
        const finalIndex =
          parseInt(oldIndex) > index
            ? parseInt(oldIndex) - 1
            : parseInt(oldIndex);
        updatedStateLists[finalIndex] = newOrgStateLists[oldIndex];
      });

    // 4. Update the state with the cleaned and re-indexed data
    setOrgStateLists(updatedStateLists);
  };
  const toggleRemove = () => {
    setShowImg(false);
  };
  const removeLogo = () => {
    setShowLogo(false);
  };
  // short logo

  const shortRemove = () => {
    setShowImg1(false);
  };

  // const removeLogo1 =()=>{

  // }

  ///SaveCall
  const submit = () => {};
  const onSubmit = (data) => {
    setIsProcess(true);
    let industryType = industryData.filter(
      (x) => x.industryName === data.industryType
    );
    const req = {
      tenantID: GV.userDet.tenantDetail.tenantID,
      tenantName: data.cname,
      tenantType: tenantInfo.tenantType,
      shortName: data.dname,
      taxID: data.taxId,
      inCorpState: tenantInfo.inCorpState,
      address1: tenantInfo.address1,
      city: tenantInfo.city,
      state: tenantInfo.state,
      zip: tenantInfo.zip,
      country: tenantInfo.country,
      website: data.siteLink,
      primaryPhone: data.pcontact,
      fax: tenantInfo.fax,
      email: data.pEmail,
      domainPrefix: tenantInfo.domainPrefix,
      tenantStatus: tenantInfo.tenantStatus,
      billAddress1: data.address1,
      billCity: data.bcity,
      billZipCode: data.bzip,
      billState: data.bstate,
      billCountry: data.bcountry,
      contactUsTelephone: tenantInfo.contactUsTelephone,
      contactUsEmailID: tenantInfo.contactUsEmailID,
      dataPartitionID: tenantInfo.dataPartitionID,
      timeZoneID: tenantInfo.timeZoneID,
      administratorName: tenantInfo.administratorName,
      administratorEmail: tenantInfo.administratorEmail,
      administratorPhone: tenantInfo.administratorPhone,
      domicileCountry: tenantInfo.domicileCountry,
      tenantKey: tenantInfo.tenantKey,
      industryID: industryType[0].industryID,
      industryType: industryType[0].industryName,
      businessType: tenantInfo.businessType,
      companyType: data.companytype,
      description: data.about,
      companyID: data.compRegId,
      licenseName: data.licenseName,
      licenseNo: data.licenseNo,
      taxNumber: data.taxNo,
      panNo: data.panNo,
      bankName: data.bankname,
      bankBranch: data.branch,
      ifscCode: data.ifsc,
      bankAccountNo: data.acctNo,
      bankAccountName: data.accntName,
      createdBy: GV.userDet.appUser.appuserID.toString(),
      OriginatingAddressList: data.orgAddresses.map((addr, index) => ({
        OrgAddressID: addr.orgAddressID || 0,
        AddressTitle: null,
        Address1: addr.orgbaddress1 || "",
        Address2: null,
        City: addr.orgbcity || "",
        State: addr.orgbstate || "",
        Country: addr.orgbcountry || "",
        ZipCode: addr.orgbzip || "",
        StateCode: null,
        IsPrimary: false,
        TenantID: GV.userDet.tenantDetail.tenantID,
        CreatedBy: GV.userDet.appUser.appuserID.toString(),
      })),
    };

    org
      .SaveTenantDetails(req)
      .then((response) => {
        setIsProcess(false);

        if (response.data?.statusCode === 200) {
          toast.current.show({
            severity: "success",
            summary: "Successfully Updated Organization Profile",
          });

          setTabVal((prev) => (prev < stepItems.length - 1 ? prev + 1 : prev));
        }
      })
      .catch(function (error) {
        setIsProcess(false);

        if (error.response?.data) {
          toast.current.show({
            severity: "error",
            summary: "Organization Profile cannot be updated",
          });
        }
      });
  };

  //   industry get call

  function getIndustry() {
    org
      .GetIndustry()
      .then((response) => {
        if (isMounted) {
          if (response.data) {
            if (response.data.statusCode === 200) {
              setTdataLoaded(true);
              setIndustryData(response.data.data);

              // if(cdataLoad === true && tdataLoaded === true){
              //     getOrganizationData();
              //   }
            } else {
              setTdataLoaded(false);
            }
          }
        }
      })
      .catch(function (error) {});
    org
      .GetCountry()
      .then((response) => {
        // if (isMounted) {
        if (response.data) {
          if (response.data.statusCode === 200) {
            const countryListed = response.data.data;
            setCountryData(countryListed);
            setOrgCountryData(countryListed);
            setCdataLoaded("Done");

            let country = response.data.data;
          } else {
            setTdataLoaded(false);
          }

          // }
        }
      })
      .catch(function (error) {});
  }

  let [stateList, setStateList] = useState([]);
  let [orgStateList, setOrgStateList] = useState([]);

  function changeCountryProfile(e) {
    setValue("bcountry", e);
    const countries = countryData.filter(
      (x) => x.countryName === getValues("bcountry")
    );
    //
    // if(v === countRef){
    org
      .GetState(countries[0].countryID)
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode === 200) {
            const state = response.data.data;
            setStateList(response.data.data);
            const check = state.filter(
              (x) => x.stateName === getValues("bstate")
            );
            if (check.length === 0) {
              setValue("bstate", "");
            } else {
              // setValue('bstate',tenantInfo?.billState);
            }
          }
        }
      })
      .catch(function (error) {});
    // }
    // setStateList(states)
    //   getState(countries[0].countryID)
  }

  function changeOrgCountryProfile(e, index) {
    setValue(`orgAddresses.${index}.orgbcountry`, e.value);

    const countries = orgCountryData.filter((x) => x.countryName === e.value);

    if (countries.length > 0) {
      org
        .GetState(countries[0].countryID)
        .then((response) => {
          if (response.data?.statusCode === 200) {
            const stateList = response.data.data;

            // store only for that index
            setOrgStateLists((prev) => ({
              ...prev,
              [index]: stateList,
            }));

            const currentState = getValues(`orgAddresses.${index}.orgbstate`);
            const check = stateList.find((x) => x.stateName === currentState);

            if (!check) {
              setValue(`orgAddresses.${index}.orgbstate`, "");
            }
          }
        })
        .catch(() => {});
    }
  }

  const tabNames = ["Company Profile", "Configuration", "Theme"];
  const [tabVal, setTabVal] = useState(0);
  const TabChange = (val) => {
    setTabVal(val);
  };

  function initialLoad() {
    getIndustry();
    // getOrganizationData();
  }

  useEffect(() => {
    if (cdataLoad === "Init") {
      initialLoad();
    }
    if (cdataLoad === "Done") {
      setTimeout(() => {
        // setCdataLoaded('changed');
        getOrganizationData();
      }, 3000);
    }

    // reset(organizationData);
    // return () => { setIsMounted(false); }
  }, [cdataLoad]);

  return (
    <>
      <Toast ref={toast}></Toast>
      {isProcess && (
        <div className="spinnerOverlay">
          <ProgressSpinner
            style={{
              width: "50px",
              height: "50px",
            }}
            strokeWidth="2"
            fill="var(--surface-ground)"
            animationDuration=".5s"
            ariaLabel="Loading"
          />
        </div>
      )}
      <BlockUI blocked={isProcess}>
       
        <div className="row">
          <Row>
            <div className="card mb-3 ms-2 me-3 card-borderless cc-greyCard-custm">
              <div className="d-flex justify-content-between align-items-center my-2">
                <div className="ms-2 my-2 me-2">
                  <div style={{ width: "300px" }}>
                    <h5 className=" text-bold m-0">{tabNames[tabVal]}</h5>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center ">
                  {/* <Tooltip target=".custom-config-icon" />
                  <Tooltip target=".custom-profile-icon" />
                  <Tooltip target=".custom-theme-icon" />
                  <IcomoonReact
                    iconSet={iconSet}
                    color="#1763af"
                    size={25}
                    icon="configure"
                    className="pointer   custom-config-icon"
                    onClick={() => TabChange("Configuration")}
                    data-pr-tooltip="Configuration"
                    data-pr-position="top"
                  />
                  <IcomoonReact
                    iconSet={iconSet}
                    color="#1763af"
                    size={25}
                    icon="Test-Service-Master-Management"
                    className="pointer  ms-5 custom-profile-icon"
                    onClick={() => TabChange("Company Profile")}
                    data-pr-tooltip="Company Profile"
                    data-pr-position="top"
                  />
                  <IcomoonReact
                    iconSet={iconSet}
                    color="#1763af"
                    size={25}
                    icon="physician"
                    className="pointer  ms-5 custom-theme-icon"
                    onClick={() => TabChange("Theme")}
                    data-pr-tooltip="Theme"
                    data-pr-position="top"
                  /> */}
                  {/* <IcomoonReact iconSet={iconSet} color="#1763af" size={25} icon='Provider-Conflict' className='pointer mt-2 ms-5' onClick={() => TabChange('Partnership Details')}/> */}

                  {/* <img src={ProfileIcon} alt="profile-image" />
                        
                        <img src={ConfigurationIcon} alt="profile-image"  className='ms-3' />


                        <img src={ConfigurationIcon} alt="profile-image"  className='ms-3'/> */}
                </div>
              </div>
            </div>
          </Row>
          {/* <div className='col-md-2 bg-white p-3'> */}
          {/* <div className="card"> */}

          {isConfigCompleted ? (
            <TabView
              activeIndex={tabVal}
              onTabChange={(e) => setTabVal(e.index)}
            >
              <TabPanel header="Company Profile">
                <div className="row">
                  <div className="col-md-9">
                    <div className="card card-borderless mb-4">
                      <div className="card-header bg-white">
                        <h5 className="mb-0 ">Basic Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Company Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("cname")}
                              disabled
                            />
                            {errors.cname && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.cname?.message}
                              </p>
                            )}
                          </div>
                          <div className="col">
                            <label className="required">Company Type</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("companytype")}
                            />
                            {errors.companytype && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.companytype?.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Display Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("dname")}
                            />
                            {errors.dname && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.dname?.message}
                              </p>
                            )}
                          </div>
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Owner
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("owner")}
                              disabled
                            />
                            {errors.owner && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.owner?.message}
                              </p>
                            )}
                          </div>

                          {/* <div className='col form-group'>
                                                <label className='form-control-label'>Domicile Country</label>
                                                <input type="text" className='form-control'  {...register('country')}
                                                   disabled />
                                            {errors.country && <p className="text-danger mb-0 ps-1">{errors.country?.message}</p>}

                                            </div> */}
                        </div>
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              {...register("pEmail")}
                              disabled
                            />
                            {/* , { required: "Email is Required",
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Invalid email address"
                                        }})}*/}
                            {errors.pEmail && (
                              <p className="text-danger mb-0">
                                {errors.pEmail.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label required">
                              Primary Contact
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("pcontact")}
                              disabled
                            />
                            {errors.pcontact && (
                              <p className="text-danger mb-0">
                                {errors.pcontact.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label ">
                              Official Website
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("siteLink")}
                            />
                            {errors.siteLink && (
                              <p className="text-danger mb-0">
                                {errors.siteLink.message}
                              </p>
                            )}
                          </div>
                          <div className="col form-group">
                            <label className="form-control-label">About</label>
                            <textarea
                              className="form-control"
                              rows="2"
                              {...register("about")}
                            />
                            {errors.about && (
                              <p className="text-danger mb-0">
                                {errors.about.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card card-borderless mb-4">
                      <div className="card-header bg-white">
                        <h5 className="mb-0 text-bold ">Company Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Industry Type
                            </label>

                            <Controller
                              render={({ field }) => (
                                <Dropdown
                                  className="input-group "
                                  options={industryData}
                                  {...field}
                                  optionLabel="industryName"
                                  optionValue="industryName"
                                  {...register("industryType")}
                                />
                              )}
                              control={control}
                              name="industryType"
                            />
                            {errors.industryType && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.industryType?.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            {/* <label className='form-control-label'>Business Type</label>

                                                <Controller
                                                    render={({ field }) => (
                                                        <Dropdown className="input-group " options={BusinessType}
                                                            {...field}

                                                            optionLabel="label" optionValue="value" />

                                                    )}
                                                    control={control}
                                                    name="businessType"
                                                    defaultValue={organizationData.businessType}
                                                />*/}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Company Registration ID
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("compRegId")}
                            />
                            {errors.compRegId && (
                              <p className="text-danger mb-0">
                                {errors.compRegId.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label required">
                              PAN Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("panNo")}
                            />
                            {errors.panNo && (
                              <p className="text-danger mb-0">
                                {errors.panNo.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label">
                              License Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("licenseName")}
                            />
                            {errors.licenseName && (
                              <p className="text-danger mb-0">
                                {errors.licenseName.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label ">
                              License Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("licenseNo")}
                            />
                            {errors.licenseNo && (
                              <p className="text-danger mb-0">
                                {errors.licenseNo.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-6 form-group">
                            <label className="form-control-label required">
                              Tax Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("taxId")}
                            />
                            {errors.taxId && (
                              <p className="text-danger mb-0">
                                {errors.taxId.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label required">
                              Tax No
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("taxNo")}
                            />
                            {errors.taxNo && (
                              <p className="text-danger mb-0">
                                {errors.taxNo.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div
                      className="card card-borderless bg-white"
                      style={{ width: "136%" }}
                    >
                      <div className="card-header bg-white">
                        <h5 className="mb-0 text-bold">Bank Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col-md-3 form-group">
                            <label className="form-control-label required">
                              Bank Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("bankname")}
                            />
                            {errors.bankname && (
                              <p className="text-danger mb-0">
                                {errors.bankname.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              Branch
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("branch")}
                            />
                            {errors.branch && (
                              <p className="text-danger mb-0">
                                {errors.branch.message}
                              </p>
                            )}
                          </div>
                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              IFSC Code
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("ifsc")}
                            />
                            {errors.ifsc && (
                              <p className="text-danger mb-0">
                                {errors.ifsc.message}
                              </p>
                            )}
                          </div>
                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              Account No
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("acctNo")}
                            />
                            {errors.acctNo && (
                              <p className="text-danger mb-0">
                                {errors.acctNo.message}
                              </p>
                            )}
                          </div>
                          <div className="col-md-3 form-group">
                            <label className="form-control-label required">
                              Account Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("accntName")}
                            />
                            {errors.accntName && (
                              <p className="text-danger mb-0">
                                {errors.accntName.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div
                      className="card card-borderless mb-4 bg-white"
                      style={{ width: "136%" }}
                    >
                      <div className="card-header bg-white">
                        <h5 className="mb-0 text-bold">Billing Address</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col-md-4 form-group">
                            <label className="form-control-label required">
                              Address Line 1
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("address1")}
                            />
                            {errors.address1 && (
                              <p className="text-danger mb-0">
                                {errors.address1.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              City
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("bcity")}
                            />
                            {errors.bcity && (
                              <p className="text-danger mb-0">
                                {errors.bcity.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              Country
                            </label>
                            <Controller
                              control={control}
                              name="bcountry"
                              render={({ field }) => (
                                <Dropdown
                                  className="col-auto text-start me-3 input-group"
                                  options={countryData}
                                  {...field}
                                  optionLabel="countryName"
                                  optionValue="countryName"
                                  scrollHeight="400px"
                                  onChange={(e) => {
                                    changeCountryProfile(e.value);
                                  }}
                                />
                              )}
                            />
                            {errors.bcountry && (
                              <p className="text-danger mb-0">
                                {errors.bcountry.message}
                              </p>
                            )}
                          </div>
                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              State
                            </label>
                            <Controller
                              render={({ field }) => (
                                <Dropdown
                                  className="col-auto text-start me-3 input-group"
                                  options={stateList}
                                  {...field}
                                  optionLabel="stateName"
                                  optionValue="stateName"
                                  {...register("bstate")}
                                  scrollHeight="400px"
                                />
                              )}
                              control={control}
                              name="bstate"
                            />
                            {errors.bstate && (
                              <p className="text-danger mb-0">
                                {errors.bstate.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              ZIP
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("bzip")}
                            />
                            {errors.bzip && (
                              <p className="text-danger mb-0">
                                {errors.bzip.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="card card-borderless  bg-white"
                      style={{ width: "136%" }}
                    >
                      <div className="card-header bg-white d-flex justify-content-between">
                        <h5 className="mb-0 text-bold">Organization Address</h5>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            append({
                              orgbaddress1: "",
                              orgbcity: "",
                              orgbstate: "",
                              orgbcountry: "",
                              orgbzip: "",
                              isNew: true,
                            })
                          }
                        >
                          + Add Another Address
                        </button>
                      </div>
                      <div className="card-body">
                        {fields.map((item, index) => (
                          <div
                            key={item.id}
                            className="border rounded p-3 mb-4 bg-light"
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h6 className="mb-0 text-primary">
                                Organization Address {index + 1}
                              </h6>
                              {item.isNew && (
                                <i
                                  className="pi pi-trash text-danger"
                                  style={{
                                    fontSize: "1.2rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleRemove(index)}
                                ></i>
                              )}
                            </div>

                            <div className="row mb-3">
                              <div className="col-md-4 form-group">
                                <label className="form-control-label required">
                                  Address Line 1
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(
                                    `orgAddresses.${index}.orgbaddress1`
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbaddress1 && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbaddress1
                                        .message
                                    }
                                  </p>
                                )}
                              </div>

                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  City
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(
                                    `orgAddresses.${index}.orgbcity`
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbcity && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbcity
                                        .message
                                    }
                                  </p>
                                )}
                              </div>

                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  Country
                                </label>
                                <Controller
                                  control={control}
                                  name={`orgAddresses.${index}.orgbcountry`}
                                  render={({ field }) => (
                                    <Dropdown
                                      className="col-auto text-start me-3 input-group"
                                      options={orgCountryData}
                                      optionLabel="countryName"
                                      optionValue="countryName"
                                      value={field.value}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        changeOrgCountryProfile(e, index);
                                      }}
                                      scrollHeight="400px"
                                    />
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbcountry && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbcountry
                                        .message
                                    }
                                  </p>
                                )}
                              </div>
                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  State
                                </label>
                                <Controller
                                  control={control}
                                  name={`orgAddresses.${index}.orgbstate`}
                                  render={({ field }) => (
                                    <Dropdown
                                      className="col-auto text-start me-3 input-group"
                                      options={orgStateLists[index] || []}
                                      optionLabel="stateName"
                                      optionValue="stateName"
                                      value={field.value}
                                      onChange={(e) => field.onChange(e.value)}
                                      scrollHeight="400px"
                                    />
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbstate && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbstate
                                        .message
                                    }
                                  </p>
                                )}
                              </div>

                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  ZIP
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(`orgAddresses.${index}.orgbzip`)}
                                />
                                {errors.orgAddresses?.[index]?.orgbzip && (
                                  <p className="text-danger mb-0">
                                    {errors.orgAddresses[index].orgbzip.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="card card-borderless bg-white mb-1"
                      style={{ width: "136%" }}
                    >
                      <div className="card-body">
                        <div className="row text-end me-0">
                          <button
                            type="button"
                            className="col-auto btn btn-primary ms-auto"
                            onClick={handleSubmit(onSubmit)}
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ height: "92vh" }}>
                    <Row className="mb-2">
                      <h6 className="col-auto  my-auto  text-black fw-bold">
                        Logo
                      </h6>
                      {showImg === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={toggleRemove}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}

                      {showLogo === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={() => removeLogo()}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}
                    </Row>

                    {showImg === true ? (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={logo}
                          alt="company-logo"
                        />
                      </div>
                    ) : showLogo === false ? (
                      <div className="col form-group">
                        <div className="drop-container dropzone">
                          <p className="mt-3">
                            <label className="upload-button ">
                              <input
                                type="file"
                                value={""}
                                accept="image/*"
                                onChange={onFileChange}
                              />{" "}
                              Drag a file here or browse to upload.
                            </label>
                          </p>
                        </div>
                        {ftypeValidate === true ? (
                          <p className="text-danger mb-0">{fileValidation}</p>
                        ) : fileValidation !== "" ? (
                          <p className="text-danger">{fileValidation}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={fileBase64String}
                          alt="compango"
                        />
                      </div>
                    )}

                    <Row className="mt-4">
                      <h6 className="col-auto  my-auto  text-black fw-bold ">
                        Short Logo
                      </h6>
                      {showImg1 === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={() => setShowImg1(false)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}

                      {showShortLogo === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={() => setShowShortLogo(false)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}
                    </Row>

                    {showImg1 === true ? (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={shortLogo}
                          alt="company-logo"
                        />
                      </div>
                    ) : showShortLogo === false ? (
                      <div className="col form-group">
                        <div className="drop-container dropzone">
                          <p className="mt-3">
                            <label className="upload-button ">
                              <input
                                type="file"
                                className="mx-2"
                                value={""}
                                accept="image/*"
                                onChange={onFileChange1}
                              />{" "}
                              Drag a file here or browse to upload.
                            </label>
                          </p>
                        </div>
                        {ftypeValidate1 === true ? (
                          <p className="text-danger mb-0">{fileValidation1}</p>
                        ) : fileValidation1 !== "" ? (
                          <p className="text-danger">{fileValidation1}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={fileBase64String1}
                          alt="compango"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </TabPanel>

              <TabPanel header="Configuration">
                <OnBoardConfig />
              </TabPanel>

              {/* <TabPanel header="Theme">
    <Configuration />
  </TabPanel> */}
            </TabView>
          ) : (
            <div>
              <Steps
  model={stepItems}
  activeIndex={tabVal}
  readOnly={false}
  onSelect={(e) => {
    // Allow only going back by click
    if (e.index <= tabVal) {
      setTabVal(e.index);
    }
  }}
/>


              {tabVal === 0 && (
                <div className="row">
                  <div className="col-md-9">
                    <div className="card card-borderless mb-4">
                      <div className="card-header bg-white">
                        <h5 className="mb-0 ">Basic Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Company Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("cname")}
                              disabled
                            />
                            {errors.cname && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.cname?.message}
                              </p>
                            )}
                          </div>
                          <div className="col">
                            <label className="required">Company Type</label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("companytype")}
                            />
                            {errors.companytype && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.companytype?.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Display Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("dname")}
                            />
                            {errors.dname && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.dname?.message}
                              </p>
                            )}
                          </div>
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Owner
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("owner")}
                              disabled
                            />
                            {errors.owner && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.owner?.message}
                              </p>
                            )}
                          </div>

                          {/* <div className='col form-group'>
                                                <label className='form-control-label'>Domicile Country</label>
                                                <input type="text" className='form-control'  {...register('country')}
                                                   disabled />
                                            {errors.country && <p className="text-danger mb-0 ps-1">{errors.country?.message}</p>}

                                            </div> */}
                        </div>
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              {...register("pEmail")}
                              disabled
                            />
                            {/* , { required: "Email is Required",
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Invalid email address"
                                        }})}*/}
                            {errors.pEmail && (
                              <p className="text-danger mb-0">
                                {errors.pEmail.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label required">
                              Primary Contact
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("pcontact")}
                              disabled
                            />
                            {errors.pcontact && (
                              <p className="text-danger mb-0">
                                {errors.pcontact.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label ">
                              Official Website
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("siteLink")}
                            />
                            {errors.siteLink && (
                              <p className="text-danger mb-0">
                                {errors.siteLink.message}
                              </p>
                            )}
                          </div>
                          <div className="col form-group">
                            <label className="form-control-label">About</label>
                            <textarea
                              className="form-control"
                              rows="2"
                              {...register("about")}
                            />
                            {errors.about && (
                              <p className="text-danger mb-0">
                                {errors.about.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card card-borderless mb-4">
                      <div className="card-header bg-white">
                        <h5 className="mb-0 text-bold ">Company Details</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Industry Type
                            </label>

                            <Controller
                              render={({ field }) => (
                                <Dropdown
                                  className="input-group "
                                  options={industryData}
                                  {...field}
                                  optionLabel="industryName"
                                  optionValue="industryName"
                                  {...register("industryType")}
                                />
                              )}
                              control={control}
                              name="industryType"
                            />
                            {errors.industryType && (
                              <p className="text-danger mb-0 ps-1">
                                {errors.industryType?.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            {/* <label className='form-control-label'>Business Type</label>

                                                <Controller
                                                    render={({ field }) => (
                                                        <Dropdown className="input-group " options={BusinessType}
                                                            {...field}

                                                            optionLabel="label" optionValue="value" />

                                                    )}
                                                    control={control}
                                                    name="businessType"
                                                    defaultValue={organizationData.businessType}
                                                />*/}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label required">
                              Company Registration ID
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("compRegId")}
                            />
                            {errors.compRegId && (
                              <p className="text-danger mb-0">
                                {errors.compRegId.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label required">
                              PAN Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("panNo")}
                            />
                            {errors.panNo && (
                              <p className="text-danger mb-0">
                                {errors.panNo.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col form-group">
                            <label className="form-control-label">
                              License Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("licenseName")}
                            />
                            {errors.licenseName && (
                              <p className="text-danger mb-0">
                                {errors.licenseName.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label ">
                              License Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("licenseNo")}
                            />
                            {errors.licenseNo && (
                              <p className="text-danger mb-0">
                                {errors.licenseNo.message}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-6 form-group">
                            <label className="form-control-label required">
                              Tax Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("taxId")}
                            />
                            {errors.taxId && (
                              <p className="text-danger mb-0">
                                {errors.taxId.message}
                              </p>
                            )}
                          </div>

                          <div className="col form-group">
                            <label className="form-control-label required">
                              Tax No
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("taxNo")}
                            />
                            {errors.taxNo && (
                              <p className="text-danger mb-0">
                                {errors.taxNo.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card card-borderless mb-4 bg-white"
                      style={{ width: "136%" }}
                    >
                      <div className="card-header bg-white">
                        <h5 className="mb-0 text-bold">Billing Address</h5>
                      </div>
                      <div className="card-body">
                        <div className="row mb-3">
                          <div className="col-md-4 form-group">
                            <label className="form-control-label required">
                              Address Line 1
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("address1")}
                            />
                            {errors.address1 && (
                              <p className="text-danger mb-0">
                                {errors.address1.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              City
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("bcity")}
                            />
                            {errors.bcity && (
                              <p className="text-danger mb-0">
                                {errors.bcity.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              Country
                            </label>
                            <Controller
                              control={control}
                              name="bcountry"
                              render={({ field }) => (
                                <Dropdown
                                  className="col-auto text-start me-3 input-group"
                                  options={countryData}
                                  {...field}
                                  optionLabel="countryName"
                                  optionValue="countryName"
                                  scrollHeight="400px"
                                  onChange={(e) => {
                                    changeCountryProfile(e.value);
                                  }}
                                />
                              )}
                            />
                            {errors.bcountry && (
                              <p className="text-danger mb-0">
                                {errors.bcountry.message}
                              </p>
                            )}
                          </div>
                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              State
                            </label>
                            <Controller
                              render={({ field }) => (
                                <Dropdown
                                  className="col-auto text-start me-3 input-group"
                                  options={stateList}
                                  {...field}
                                  optionLabel="stateName"
                                  optionValue="stateName"
                                  {...register("bstate")}
                                  scrollHeight="400px"
                                />
                              )}
                              control={control}
                              name="bstate"
                            />
                            {errors.bstate && (
                              <p className="text-danger mb-0">
                                {errors.bstate.message}
                              </p>
                            )}
                          </div>

                          <div className="col-md-2 form-group">
                            <label className="form-control-label required">
                              ZIP
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register("bzip")}
                            />
                            {errors.bzip && (
                              <p className="text-danger mb-0">
                                {errors.bzip.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="card card-borderless mb-4 bg-white"
                      style={{ width: "136%" }}
                    >
                      <div className="card-header bg-white d-flex justify-content-between">
                        <h5 className="mb-0 text-bold">Organization Address</h5>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            append({
                              orgbaddress1: "",
                              orgbcity: "",
                              orgbstate: "",
                              orgbcountry: "",
                              orgbzip: "",
                              isNew: true,
                            })
                          }
                        >
                          + Add Another Address
                        </button>
                      </div>
                      <div className="card-body">
                        {fields.map((item, index) => (
                          <div
                            key={item.id}
                            className="border rounded p-3 mb-4 bg-light"
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h6 className="mb-0 text-primary">
                                Organization Address {index + 1}
                              </h6>
                              {item.isNew && (
                                <i
                                  className="pi pi-trash text-danger"
                                  style={{
                                    fontSize: "1.2rem",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleRemove(index)}
                                ></i>
                              )}
                            </div>

                            <div className="row mb-3">
                              <div className="col-md-4 form-group">
                                <label className="form-control-label required">
                                  Address Line 1
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(
                                    `orgAddresses.${index}.orgbaddress1`
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbaddress1 && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbaddress1
                                        .message
                                    }
                                  </p>
                                )}
                              </div>

                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  City
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(
                                    `orgAddresses.${index}.orgbcity`
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbcity && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbcity
                                        .message
                                    }
                                  </p>
                                )}
                              </div>

                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  Country
                                </label>
                                <Controller
                                  control={control}
                                  name={`orgAddresses.${index}.orgbcountry`}
                                  render={({ field }) => (
                                    <Dropdown
                                      className="col-auto text-start me-3 input-group"
                                      options={orgCountryData}
                                      optionLabel="countryName"
                                      optionValue="countryName"
                                      value={field.value}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        changeOrgCountryProfile(e, index);
                                      }}
                                      scrollHeight="400px"
                                    />
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbcountry && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbcountry
                                        .message
                                    }
                                  </p>
                                )}
                              </div>
                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  State
                                </label>
                                <Controller
                                  control={control}
                                  name={`orgAddresses.${index}.orgbstate`}
                                  render={({ field }) => (
                                    <Dropdown
                                      className="col-auto text-start me-3 input-group"
                                      options={orgStateLists[index] || []}
                                      optionLabel="stateName"
                                      optionValue="stateName"
                                      value={field.value}
                                      onChange={(e) => field.onChange(e.value)}
                                      scrollHeight="400px"
                                    />
                                  )}
                                />
                                {errors.orgAddresses?.[index]?.orgbstate && (
                                  <p className="text-danger mb-0">
                                    {
                                      errors.orgAddresses[index].orgbstate
                                        .message
                                    }
                                  </p>
                                )}
                              </div>

                              <div className="col-md-2 form-group">
                                <label className="form-control-label required">
                                  ZIP
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(`orgAddresses.${index}.orgbzip`)}
                                />
                                {errors.orgAddresses?.[index]?.orgbzip && (
                                  <p className="text-danger mb-0">
                                    {errors.orgAddresses[index].orgbzip.message}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div
                      className="card card-borderless bg-white mb-1"
                      style={{ width: "136%" }}
                    >
                      <div className="card-body">
                        <div className="row text-end me-0">
                          <button
                            type="button"
                            className="col-auto btn btn-primary ms-auto"
                            onClick={handleSubmit(onSubmit)}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3" style={{ height: "92vh" }}>
                    <Row className="mb-2">
                      <h6 className="col-auto  my-auto  text-black fw-bold">
                        Logo
                      </h6>
                      {showImg === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={toggleRemove}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}

                      {showLogo === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={() => removeLogo()}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}
                    </Row>

                    {showImg === true ? (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={logo}
                          alt="company-logo"
                        />
                      </div>
                    ) : showLogo === false ? (
                      <div className="col form-group">
                        <div className="drop-container dropzone">
                          <p className="mt-3">
                            <label className="upload-button ">
                              <input
                                type="file"
                                value={""}
                                accept="image/*"
                                onChange={onFileChange}
                              />{" "}
                              Drag a file here or browse to upload.
                            </label>
                          </p>
                        </div>
                        {ftypeValidate === true ? (
                          <p className="text-danger mb-0">{fileValidation}</p>
                        ) : fileValidation !== "" ? (
                          <p className="text-danger">{fileValidation}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={fileBase64String}
                          alt="compango"
                        />
                      </div>
                    )}

                    <Row className="mt-4">
                      <h6 className="col-auto  my-auto  text-black fw-bold ">
                        Short Logo
                      </h6>
                      {showImg1 === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={() => setShowImg1(false)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}

                      {showShortLogo === true ? (
                        <button
                          type="submit"
                          className="col-auto ms-auto  text-danger pt-0 mt-0 mb-1"
                          onClick={() => setShowShortLogo(false)}
                        >
                          <RiDeleteBin5Line />
                        </button>
                      ) : (
                        ""
                      )}
                    </Row>

                    {showImg1 === true ? (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={shortLogo}
                          alt="company-logo"
                        />
                      </div>
                    ) : showShortLogo === false ? (
                      <div className="col form-group">
                        <div className="drop-container dropzone">
                          <p className="mt-3">
                            <label className="upload-button ">
                              <input
                                type="file"
                                className="mx-2"
                                value={""}
                                accept="image/*"
                                onChange={onFileChange1}
                              />{" "}
                              Drag a file here or browse to upload.
                            </label>
                          </p>
                        </div>
                        {ftypeValidate1 === true ? (
                          <p className="text-danger mb-0">{fileValidation1}</p>
                        ) : fileValidation1 !== "" ? (
                          <p className="text-danger">{fileValidation1}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <div>
                        <img
                          width="400"
                          height="400"
                          className="mt-2 border"
                          src={fileBase64String1}
                          alt="compango"
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              {tabVal === 1 && <OnBoardConfig />}
            </div>
          )}
        </div>
      </BlockUI>
    </>
  );
}
